import FieldKeyConstants from './fieldKeys';
import areValuesEqual from './areValuesEqual';

type Row = Record<string, unknown>;

const isRowOmitted = (rowValues: Row): boolean => areValuesEqual(
  rowValues[FieldKeyConstants.MASTER_CREDITOR_LIST_OMIT_FROM_PDFS_FIELD_KEY],
  ['omit'],
);

export default isRowOmitted;
